import { render, staticRenderFns } from "./exhibition-template-factory.vue?vue&type=template&id=0d290f32&scoped=true&"
import script from "./exhibition-template-factory.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-factory.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-factory.vue?vue&type=style&index=0&id=0d290f32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d290f32",
  null
  
)

export default component.exports